import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import template from "@/views/module/production/settings/template.vue";
import templateView from "@/views/module/production/settings/templateView.vue";
import createRequisition from "@/views/module/production/rawMaterialRequisition/createRequisition.vue";
import requisitionList from "@/views/module/production/rawMaterialRequisition/requisitionList.vue";
import requisitionDetails from "@/views/module/production/rawMaterialRequisition/requisitionDetails.vue";
import createRequisitionReceive from "@/views/module/production/rawMaterialRequisitionReceive/createRequisitionReceive.vue";
import requisitionReceiveList from "@/views/module/production/rawMaterialRequisitionReceive/requisitionReceiveList.vue";
import requisitionReceiveDetails from "@/views/module/production/rawMaterialRequisitionReceive/requisitionReceiveDetails.vue";
import pendingSaleOrderForProduction from "@/views/module/production/salesOrders/pendingForProduction.vue";
import ongoingSaleOrderForProduction from "@/views/module/production/salesOrders/ongoingForProduction.vue";
import completedSaleOrderForProduction from "@/views/module/production/salesOrders/completedForProduction.vue";
import saleOrderDetails from "@/views/module/production/salesOrders/saleOrderDetails.vue";
import productionRawMaterialStock from "@/views/module/production/productionInventory/rawMaterialStock.vue";
import productionFinishedGoodStock from "@/views/module/production/productionInventory/finishedGoodStock.vue";
import createProduction from "@/views/module/production/production/createProduction.vue";
import productionList from "@/views/module/production/production/productionList.vue";
import productionDetails from "@/views/module/production/production/productionDetails.vue";
import createDelivery from "@/views/module/production/delivery/createDelivery.vue";
import deliveryList from "@/views/module/production/delivery/deliveryList.vue";
import deliveryDetails from "@/views/module/production/delivery/deliveryDetails.vue";

export default [
{
    path: "/production",
    name: "production",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Buying House Production",
    },
    children: [
        {
            path: "production-templates",
            name: "production-templates",
            meta: {
                breadcrumb: ["Production", "Templates"],
            },
            component: template,
        },
        {
            path: "production-template-view/:id",
            name: "production-template-view",
            meta: {
                breadcrumb: ["Production", "Templates View"],
            },
            component: templateView,
        },
        {
            path: "create-requisition/:id?",
            name: "create-requisition",
            meta: {
                breadcrumb: ["Production", "Create Requisition"],
            },
            component: createRequisition,
        },
        {
            path: "requisition-list",
            name: "production-requisition-list",
            meta: {
                breadcrumb: ["Production", "Requisition List"],
            },
            component: requisitionList,
        },
        {
            path: "production-requisition-details/:id",
            name: "production-requisition-details",
            meta: {
                breadcrumb: ["Production", "Production Requisition details"],
            },
            component: requisitionDetails,
        },
        {
            path: "create-requisition-receive/:id?",
            name: "create-requisition-receive",
            meta: {
                breadcrumb: ["Production", "Create Requisition Receive"],
            },
            component: createRequisitionReceive,
        },
        {
            path: "requisition-receive-list",
            name: "requisition-receive-list",
            meta: {
                breadcrumb: ["Production", "Requisition Receive List"],
            },
            component: requisitionReceiveList,
        },
        {
            path: "production-requisition-receive-details/:id",
            name: "production-requisition-receive-details",
            meta: {
                breadcrumb: ["Production", "Production Requisition Receive details"],
            },
            component: requisitionReceiveDetails,
        },
        {
            path: "pending/sales-order",
            name: "pending-sales-order",
            meta: {
                breadcrumb: ["Production", "Pending Sale Orders"],
            },
            component: pendingSaleOrderForProduction,
        },
        {
            path: "ongoing/sales-order",
            name: "ongoing-sales-order",
            meta: {
                breadcrumb: ["Production", "Ongoing Sale Orders"],
            },
            component: ongoingSaleOrderForProduction,
        },
        {
            path: "completed/sales-order",
            name: "completed-sales-order",
            meta: {
                breadcrumb: ["Production", "Completed Sale Orders"],
            },
            component: completedSaleOrderForProduction,
        },
        {
            path: "production-sale-order-details/:id",
            name: "production-sale-order-details",
            meta: {
                breadcrumb: ["Production", "Sale Order Details"],
            },
            component: saleOrderDetails,
        },
        
        {
            path: "raw-material-stock",
            name: "raw-material-stock",
            meta: {
                breadcrumb: ["Production", "Raw Material Stock"],
            },
            component: productionRawMaterialStock,
        },
        {
            path: "finished-goods-stock",
            name: "finished-goods-stock",
            meta: {
                breadcrumb: ["Production", "Finished Good Stock"],
            },
            component: productionFinishedGoodStock,
        },

        {
            path: "create-production/:id?",
            name: "create-production",
            meta: {
                breadcrumb: ["Production", "Create Production"],
            },
            component: createProduction,
        },
        {
            path: "production-list",
            name: "production-list",
            meta: {
                breadcrumb: ["Production", "Production List"],
            },
            component: productionList,
        },
        {
            path: "production-details/:id",
            name: "production-details",
            meta: {
                breadcrumb: ["Production", "Production Details"],
            },
            component: productionDetails,
        },


        {
            path: "create-delivery/:id?",
            name: "create-delivery",
            meta: {
                breadcrumb: ["Production", "Create Delivery"],
            },
            component: createDelivery,
        },
        {
            path: "delivery-list",
            name: "delivery-list",
            meta: {
                breadcrumb: ["Production", "Delivery List"],
            },
            component: deliveryList,
        },

        {
            path: "production-delivery-details/:id",
            name: "production-delivery-details",
            meta: {
                breadcrumb: ["Production", "Delivery Details"],
            },
            component: deliveryDetails,
        },

    ],
  },
];
